import React from 'react';

import { useEffect } from 'react';

import { useNavigate, Link } from 'react-router-dom';

import { Container, FormControl, FormGroup, FormLabel } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';
import { Table } from 'react-bootstrap';

import { Button } from 'react-bootstrap';
import { ButtonGroup } from 'react-bootstrap';

import ServerSettingsStore from '../../../stores/ServerSettingsStore';

const ServerSettingsPanel = ({}) => {
    const store = ServerSettingsStore((state) => state);

    useEffect(() => {
        store.load();
        // The [] is for specifying dependencies, and for componentDidMount lifecycle equivalent
        // we need to specify no dependencies.
        // See https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component
    }, []);

    if (null == store.serverSettings) {
        return null;
    }

    return (
        <Container style={{ marginTop: '10px', width: '100%' }}>
            <br />
            <Row className="show-Container">
                <Col xs={12} md={8}>
                    <h3>Server Settings</h3>

                    <div style={{ marginTop: '15px' }}>
                        <FormGroup
                            controlId={'Search-text-input'}
                            style={{ marginBottom: '18px' }}
                        >
                            <FormLabel>Main Page Video Url</FormLabel>
                            <FormControl
                                type="text"
                                value={store.serverSettings.mainPageVideoUrl}
                                onChange={(e) => {
                                    store.updateAttribute(
                                        'mainPageVideoUrl',
                                        e.target.value,
                                    );
                                }}
                            />
                            <Link
                                to={store.serverSettings.mainPageVideoUrl}
                                target="_blank"
                            >
                                Test
                            </Link>
                        </FormGroup>

                        <FormGroup
                            controlId={'isMainPageVideo-visible'}
                            style={{ marginBottom: '18px' }}
                        >
                            <FormLabel>
                                Is Main Page Video Url Visible ?
                            </FormLabel>
                            <ButtonGroup style={{ marginLeft: '10px' }}>
                                <Button
                                    variant={
                                        store.serverSettings
                                            .isMainPageVideoUrlVisible
                                            ? 'primary'
                                            : 'secondary'
                                    }
                                    onClick={() => {
                                        store.updateAttribute(
                                            'isMainPageVideoUrlVisible',
                                            true,
                                        );
                                    }}
                                >
                                    Visible
                                </Button>
                                <Button
                                    variant={
                                        store.serverSettings
                                            .isMainPageVideoUrlVisible
                                            ? 'secondary'
                                            : 'primary'
                                    }
                                    onClick={() => {
                                        store.updateAttribute(
                                            'isMainPageVideoUrlVisible',
                                            false,
                                        );
                                    }}
                                >
                                    Hide
                                </Button>
                            </ButtonGroup>
                        </FormGroup>

                        <FormGroup
                            controlId={'Search-text-input'}
                            style={{ marginBottom: '18px' }}
                        >
                            <FormLabel>
                                Scientific Quality Explanation Pdf Url
                            </FormLabel>
                            <FormControl
                                type="text"
                                value={
                                    store.serverSettings.scientificQualityPdfUrl
                                }
                                onChange={(e) => {
                                    store.updateAttribute(
                                        'scientificQualityPdfUrl',
                                        e.target.value,
                                    );
                                }}
                            />
                            <Link
                                to={
                                    store.serverSettings.scientificQualityPdfUrl
                                }
                                target="_blank"
                            >
                                Test
                            </Link>
                        </FormGroup>

                        <FormGroup
                            controlId={'Search-text-input'}
                            style={{ marginBottom: '18px' }}
                        >
                            <FormLabel>Site Contents As Pdf File Url</FormLabel>
                            <FormControl
                                type="text"
                                value={
                                    store.serverSettings.siteContentsAsPdfUrl
                                }
                                onChange={(e) => {
                                    store.updateAttribute(
                                        'siteContentsAsPdfUrl',
                                        e.target.value,
                                    );
                                }}
                            />

                            <Link
                                to={store.serverSettings.siteContentsAsPdfUrl}
                                target="_blank"
                            >
                                Test
                            </Link>
                        </FormGroup>

                        <FormGroup
                            controlId={'Search-text-input'}
                            style={{ marginBottom: '18px' }}
                        >
                            <FormLabel>
                                Email Address for Share Feedback Button
                            </FormLabel>
                            <FormControl
                                type="text"
                                value={
                                    store.serverSettings
                                        .shareFeedbackEmailAddress
                                }
                                onChange={(e) => {
                                    store.updateAttribute(
                                        'shareFeedbackEmailAddress',
                                        e.target.value,
                                    );
                                }}
                            />

                            <Link
                                to={
                                    'mailto:' +
                                    store.serverSettings
                                        .shareFeedbackEmailAddress
                                }
                                target="_blank"
                            >
                                Test
                            </Link>
                        </FormGroup>

                        <FormGroup
                            controlId={
                                'isFrontPageResourceCreationDateVisible-visible'
                            }
                            style={{ marginBottom: '18px' }}
                        >
                            <FormLabel>
                                Is Date Visible for Front Page Neuigkeiten ?
                            </FormLabel>
                            <ButtonGroup style={{ marginLeft: '10px' }}>
                                <Button
                                    variant={
                                        store.serverSettings
                                            .isFrontPageResourceCreationDateVisible
                                            ? 'primary'
                                            : 'secondary'
                                    }
                                    onClick={() => {
                                        store.updateAttribute(
                                            'isFrontPageResourceCreationDateVisible',
                                            true,
                                        );
                                    }}
                                >
                                    Visible
                                </Button>
                                <Button
                                    variant={
                                        store.serverSettings
                                            .isFrontPageResourceCreationDateVisible
                                            ? 'secondary'
                                            : 'primary'
                                    }
                                    onClick={() => {
                                        store.updateAttribute(
                                            'isFrontPageResourceCreationDateVisible',
                                            false,
                                        );
                                    }}
                                >
                                    Hide
                                </Button>
                            </ButtonGroup>
                        </FormGroup>

                        <FormGroup
                            controlId={
                                'isSingleMaterialCreationDateVisible-visible'
                            }
                            style={{ marginBottom: '18px' }}
                        >
                            <FormLabel>
                                Is Date Visible on Aufbereitung Page ?
                            </FormLabel>
                            <ButtonGroup style={{ marginLeft: '10px' }}>
                                <Button
                                    variant={
                                        store.serverSettings
                                            .isSingleMaterialCreationDateVisible
                                            ? 'primary'
                                            : 'secondary'
                                    }
                                    onClick={() => {
                                        store.updateAttribute(
                                            'isSingleMaterialCreationDateVisible',
                                            true,
                                        );
                                    }}
                                >
                                    Visible
                                </Button>
                                <Button
                                    variant={
                                        store.serverSettings
                                            .isSingleMaterialCreationDateVisible
                                            ? 'secondary'
                                            : 'primary'
                                    }
                                    onClick={() => {
                                        store.updateAttribute(
                                            'isSingleMaterialCreationDateVisible',
                                            false,
                                        );
                                    }}
                                >
                                    Hide
                                </Button>
                            </ButtonGroup>
                        </FormGroup>

                        <FormGroup
                            controlId={
                                'isDirectoryPageMaterialsCreationDateVisible-visible'
                            }
                            style={{ marginBottom: '18px' }}
                        >
                            <FormLabel>
                                Is Date Visible on Main Search Page (i.e.,
                                Directory Page) ?
                            </FormLabel>
                            <ButtonGroup style={{ marginLeft: '10px' }}>
                                <Button
                                    variant={
                                        store.serverSettings
                                            .isDirectoryPageMaterialsCreationDateVisible
                                            ? 'primary'
                                            : 'secondary'
                                    }
                                    onClick={() => {
                                        store.updateAttribute(
                                            'isDirectoryPageMaterialsCreationDateVisible',
                                            true,
                                        );
                                    }}
                                >
                                    Visible
                                </Button>
                                <Button
                                    variant={
                                        store.serverSettings
                                            .isDirectoryPageMaterialsCreationDateVisible
                                            ? 'secondary'
                                            : 'primary'
                                    }
                                    onClick={() => {
                                        store.updateAttribute(
                                            'isDirectoryPageMaterialsCreationDateVisible',
                                            false,
                                        );
                                    }}
                                >
                                    Hide
                                </Button>
                            </ButtonGroup>
                        </FormGroup>
                    </div>

                    <Button
                        style={{ marginLeft: '5px' }}
                        onClick={() => {
                            store.save(
                                store.serverSettings,
                                () => {
                                    alert('The settings were saved');
                                },
                                () => {
                                    alert('Something went wrong!');
                                },
                            );
                        }}
                    >
                        Save
                    </Button>
                </Col>
            </Row>
        </Container>
    );
};

export default ServerSettingsPanel;
